<!-- Made with <i class="fa fa-heart"></i> with bootstrap and font-awesome -->
<!-- <app-header></app-header> -->
<app-header-new></app-header-new>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-loading></app-loading>
<app-modal></app-modal>